import { render, staticRenderFns } from "./AlertLink.vue?vue&type=template&id=149e9b25"
import script from "./AlertLink.vue?vue&type=script&lang=js"
export * from "./AlertLink.vue?vue&type=script&lang=js"
import style0 from "./AlertLink.vue?vue&type=style&index=0&id=149e9b25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports